/* eslint-disable react/prop-types */
import { Box } from '@material-ui/core';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import CircleIcon from '@material-ui/icons/FiberManualRecord';

class StepBar extends React.Component {
  render() {
    let fontColor1;
    fontColor1 = '#DADBDB';
    let fontColor2;
    fontColor2 = '#DADBDB';
    let fontColor3;
    fontColor3 = '#DADBDB';
    let fontColor4;
    fontColor4 = '#DADBDB';
    switch (this.props.step) {
      case 'step1':
        fontColor1 = '#9B88FF';
        break;
      case 'step2':
        fontColor2 = '#9B88FF';
        break;
      case 'step3':
        fontColor3 = '#9B88FF';
        break;
      case 'step4':
        fontColor4 = '#9B88FF';
        break;
    }

    return (
      <div>
        <Box marginTop={8} textAlign="center" width={200} m="auto">
          <Grid container alignItems="center" textAlign="center" justify="center">
            <Grid item xs={3}>
              <Box color={fontColor1}>
                <h4 className="stepbar">STEP1</h4>
                <CircleIcon style={{ fontSize: 12 }} />
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box color={fontColor2}>
                <h4 className="stepbar"> STEP2</h4>
                <CircleIcon style={{ fontSize: 12 }} />
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box color={fontColor3}>
                <h4 className="stepbar">STEP3</h4>
                <CircleIcon style={{ fontSize: 12 }} />
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box color={fontColor4}>
                <h4 className="stepbar">STEP4</h4>
                <CircleIcon style={{ fontSize: 12 }} />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    );
  }
}

export default StepBar;
